// Push messaging on the browser using Twilio Sync and Firebase.
//
// Twilio Sync uses web sockets, so always available in the browsers we target.
//
// Firebase gives us native notifications in desktop and mobile browsers.
// Firebase doesn't work on all browsers, and also needs permission from the user.
//
// So we connect with Twilio Sync first and then upgrade to Firebase if possible.


import * as firebase from './firebase';
import * as twilio   from './twilio';


export async function enableNotifications({ onToken, onNotification, onDataMessage }) {
  if (firebase.isSupported()) {
    await firebase.start({
      onToken,
      onNotification,
      onDataMessage,
      onGranted: onPushGranted,
      onDenied:  onPushDenied
    });
  } else
    await twilio.start({ onNotification, onDataMessage });


  // Going with Firebase, stop Twilio.
  async function onPushGranted() {
    await twilio.stop();
  }

  // Push notification permission denied or unknown, need to fall back
  // on Twilio for now.
  async function onPushDenied() {
    await twilio.start({ onToken, onNotification, onDataMessage });
  }
}


export async function disableNotifications() {
  await Promise.all([
    stopFirebase(),
    twilio.stop()
  ]);
}


export function getNotificationState() {
  return Notification.permission;
}


// Badge in window title handled by WindowTitle component.
export function setBadgeCount({ number }) {
  // https://web.dev/badging-api
  if (navigator.setAppBadge)
    navigator.setAppBadge(number);
}


async function stopFirebase() {
  if (firebase.isSupported())
    await firebase.stop();
}
